import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

var BtnStarOff = function BtnStarOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.864 14l.886-5.065L0 5.347l5.183-.74L7.5 0l2.318 4.608 5.182.74-3.75 3.587.887 5.065-4.638-2.393L2.864 14zM7.5 10.482l3.305 1.706-.631-3.607 2.648-2.535-3.662-.522L7.5 2.225 5.84 5.524l-3.662.522 2.649 2.535-.63 3.606L7.5 10.482z"
  }));
};

BtnStarOff.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 14"
};

var BtnStarOn = function BtnStarOn(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0l2.319 4.608L15 5.347l-3.75 3.588.887 5.065-4.638-2.393L2.864 14l.886-5.065L0 5.347l5.183-.74z"
  }));
};

BtnStarOn.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 14"
};

var BtnTrash = function BtnTrash(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.773 18h-8.5c-1.224 0-2.22-.923-2.22-2.057L1 5.503A.501.501 0 0 1 1.5 5h11.946a.5.5 0 0 1 .5.498L14 15.94c0 1.137-.999 2.06-2.227 2.06zM2.003 6l.05 9.94v.002c0 .574.558 1.058 1.22 1.058h8.5C12.44 17 13 16.516 13 15.942L12.95 6H2.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6H.5a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 .5 2h14a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5zM1 5h13V3H1v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3h-6a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zM5 2h5V1H5v1zM10.5 15a.5.5 0 0 1-.5-.5v-6a.5.5 0 1 1 1 0v6a.5.5 0 0 1-.5.5zM7.5 15a.5.5 0 0 1-.5-.5v-6a.5.5 0 1 1 1 0v6a.5.5 0 0 1-.5.5zM4.5 15a.5.5 0 0 1-.5-.5v-6a.5.5 0 1 1 1 0v6a.5.5 0 0 1-.5.5z"
  }));
};

BtnTrash.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};
import Icon from "../Icon";
import IconButton from "../IconButton";
import Checkbox from "../Checkbox";
import Fade from "../Fade";
import Row from "../Layout/Row";
import createStyles from "../createStyles";
var useStyles = createStyles({
  root: {
    minWidth: 60
  }
});
var InputActions = /*#__PURE__*/React.forwardRef(function InputActions(_ref, ref) {
  var _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? false : _ref$primary,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      _ref$onRemove = _ref.onRemove,
      onRemove = _ref$onRemove === void 0 ? noop : _ref$onRemove,
      _ref$onStar = _ref.onStar,
      onStar = _ref$onStar === void 0 ? noop : _ref$onStar,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Fade, {
    className: classes.root,
    ref: ref,
    show: show || primary
  }, /*#__PURE__*/React.createElement(Row, {
    wrap: false,
    align: "center",
    justify: "end"
  }, !primary && !disabled && /*#__PURE__*/React.createElement(IconButton, {
    color: "secondary",
    disabled: disabled,
    name: name,
    onClick: onRemove
  }, /*#__PURE__*/React.createElement(BtnTrash, {
    height: 18,
    width: 15
  })), (primary || !disabled) && /*#__PURE__*/React.createElement(Checkbox, {
    position: "suffix",
    checked: primary,
    name: name,
    onChange: onStar,
    disabled: disabled,
    icon: /*#__PURE__*/React.createElement(Icon, {
      width: 17,
      height: 15,
      svg: BtnStarOff
    }),
    checkedIcon: /*#__PURE__*/React.createElement(Icon, {
      width: 15,
      height: 14,
      svg: BtnStarOn
    })
  })));
});
InputActions.propTypes = {
  show: PropTypes.bool,
  primary: PropTypes.bool,
  onRemove: PropTypes.func,
  onStar: PropTypes.func,
  disabled: PropTypes.bool
};
export default InputActions;